import { namespace } from 'vuex-class';
import { IResourceLibraryState } from '@/content-library/resource-library/store/resource-library.types';
import { EResourceSortAttribute } from '@/api/resources/types/enum/resource-sort-attribute';
import { ESortOrder } from '@/api/resources/types/enum/sort-order';

export const ResourceLibrary = namespace('contentLibrary/resourceLibrary');

export const state: IResourceLibraryState = {
  loading: false,
  loaded: false,
  resources: [],
  totalCount: 0,
  payload: {
    limit: 12,
    offset: 0,
    currentPage: 1,
    filter: {
      directory: undefined,
      type: null,
      searchTerms: [],
      sortBy: EResourceSortAttribute.UpdatedAt,
      sortOrder: ESortOrder.Desc,
    },
  },
  breadcrumbs: [
    {
      label: '',
      icon: 'folder',
    },
  ],
};

export enum EResourceLibraryAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  SetPayload = 'setPayload',
  Reset = 'reset',
  UpdateFilter = 'updateFilter',
  UpdateBreadcrumbs = 'updateBreadcrumbs',
}

export enum EResourceLibraryMutation {
  SetResources = 'setResources',
  SetLoading = 'setLoading',
  SetLoaded = 'setLoaded',
  SetPayload = 'setPayload',
  SetState = 'setState',
  SetFilter = 'setFilter',
  SetBreadcrumbs = 'setBreadcrumbs',
}
